import { IFileRelation } from './IFileRelation';

export class TempFileRelation implements IFileRelation {
  own_backend: string;
  related_model: string;
  related_backend: string;
  related_id: string;
  type: string;

  constructor(fileRelation: Partial<TempFileRelation> = {}) {
    fileRelation = {
      own_backend: 'Sql',
      related_model: 'Filemanager_Model_Node',
      related_backend: 'Sql',
      type: 'TEMPFILE',
      ...fileRelation
    };
    Object.assign(this, fileRelation);
  }
}
